import { withTranslation } from "react-i18next";
import { useSelector, useDispatch } from "react-redux";
import { ThemeProvider } from "styled-components";
import { useEffect, useState } from "react";

// own states
import { State, AppDispatch } from "../../Redux/Store";

import { GetProfessions } from "../../Redux/Professions/Professions.action";
import { GetTelephoneCompanies } from "../../Redux/TelephoneCompanies/TelephoneCompanies.action";

import { GET_PROFESSIONS_FULFILLED } from "../../Constants/Professions";
import { GET_TELEPHONE_COMPANIES_FULFILLED } from "../../Constants/TelephoneCompanies";

// Own components
import Layout from "../../Components/Layout";
import Jumbotron from "../../Components/Jumbotrom";
import Title from "../../Components/Title";
import Text from "../../Components/Text";
import { Column, Container, Row } from "../../Components/Grid";
import Image from "../../Components/Image";
import StepsCard from "../../Components/StepsCard";
import BeneficiaryForm from "./Components/BeneficiaryForm";
import Icon from "../../Components/Icon";

import bgHome from "../../Assets/Img/bgHome.png";
import ImgGT3 from "../../Assets/Img/ImgG&T3.png";
import ImgGT2 from "../../Assets/Img/ImgG&T2.png";
import ImgGT from "../../Assets/Img/ImgG&T.png";
import LogoGT from "../../Assets/Img/LogoG&T2.png";
import BankClock from "../../Assets/Img/banckClock.svg";

import {
  CardSection,
  CardSectionAccount,
  IconCard,
  IconSectionStep,
  IconsSection,
  IconsSectionAccount,
  ImgMobile,
  Description,
  DescriptionStep,
  Section,
  SectionAccount,
  SectionInicia,
  SectionMobile,
  Span,
  StepSection,
  TitleSection,
  TitleSectionStep,
  ContainerSection,
  ImageContainer,
} from "./HomePage.styled";

const HomePage = () => {
  const theme = useSelector((state: State) => state.theme);
  const dispatch = useDispatch<AppDispatch>();
  const [professionsList, setProfessionsList] = useState([]);
  const [telephoneList, setTelephoneList] = useState([]);

  const GetProfessionsList = async () => {
    const response = await dispatch(GetProfessions());

    if (response?.type === GET_PROFESSIONS_FULFILLED) {
      setProfessionsList(response.payload);
    }
  };

  const GetTelephone = async () => {
    const response = await dispatch(GetTelephoneCompanies());

    if (response?.type === GET_TELEPHONE_COMPANIES_FULFILLED) {
      setTelephoneList(response.payload);
    }
  };

  useEffect(() => {
    GetProfessionsList();
    GetTelephone();
  }, []);

  return (
    <ThemeProvider theme={theme}>
      <Layout>
        <Container>
          <SectionMobile>
            <Row>
              <Column span={12}>
                <Row>
                  <Column span={12} as={ContainerSection}>
                    <Title
                      color="blue"
                      tagName={"h1"}
                      size={3}
                      text="Con unos clicks, abre tu Cuenta de Remesa Activa con Banco G&T"
                      align="center"
                      margin="48px 0"
                    />
                    <Text
                      size={2}
                      color="Neutral_900"
                      align="center"
                      margin="48px 0"
                    >
                      La cuenta para personas imparables como tú. Haz que tu
                      familia reciba dinero del extranjero, rápido y confiable.
                    </Text>
                  </Column>
                </Row>
                <ImgMobile />
              </Column>
            </Row>
          </SectionMobile>
          <Jumbotron image={bgHome} align="center">
            <Row>
              <Column span={9} xs={12}>
                <TitleSection>
                  <Title
                    color="white"
                    tagName="h1"
                    size={9}
                    text="Con unos clicks, abre tu Cuenta de Remesa Activa con Banco G&T"
                    align="left"
                  />
                  <Text size={5} color="white" align="left">
                    La cuenta para personas imparables como tú. Haz que tu
                    familia reciba dinero del extranjero, rápido y confiable.
                  </Text>
                </TitleSection>
              </Column>
            </Row>
          </Jumbotron>
          <Row>
            <Column span={12}>
              <Section>
                <Text size={6} color="Eerie_Black" margin="0">
                  Conoce los beneficios de aperturar una cuenta de remesa activa
                </Text>
                <Text size={6} weight={600} color="Primary_600" margin="0">
                  En Banco G&T Continental
                </Text>
              </Section>
              <IconsSection>
                <CardSection>
                  <IconCard>
                    <Icon
                      icon="creditCard"
                      size="xxlarge"
                      color="Primary_600"
                    />
                  </IconCard>
                  <Text
                    size={3}
                    color="Eerie_Black"
                    weight={600}
                    margin="32px 0"
                  >
                    Tarjeta de Débito Titular
                  </Text>
                </CardSection>
                <CardSection>
                  <IconCard>
                    <Icon icon="lightning" size="xxlarge" color="Primary_600" />
                  </IconCard>
                  <Text
                    size={3}
                    color="Eerie_Black"
                    weight={600}
                    margin="32px 0"
                  >
                    Banca Electrónica sin costo
                  </Text>
                </CardSection>
              </IconsSection>
            </Column>
          </Row>
          <Row>
            <Column span={12} as={SectionAccount}>
              <Title
                color="Eerie_Black"
                tagName="h1"
                size={9}
                text="Pasos para aperturar tu cuenta"
                margin="99px 0"
              />
              <IconsSectionAccount>
                <CardSectionAccount>
                  <StepSection>1</StepSection>
                  <Icon icon="user" size="xxxlarge" color="Primary_600" />
                  <Text size={3} color="Eerie_Black" weight={600} margin="0">
                    Completa tu Información personal
                  </Text>
                </CardSectionAccount>
                <CardSectionAccount>
                  <StepSection>2</StepSection>
                  <Icon icon="bank" size="xxxlarge" color="Primary_600" />
                  <Text size={3} color="Eerie_Black" weight={600} margin="0">
                    Apertura de Cuenta
                  </Text>
                </CardSectionAccount>
                <CardSectionAccount>
                  <StepSection>3</StepSection>
                  <Icon icon="write" size="xxxlarge" color="Primary_600" />
                  <Text size={3} color="Eerie_Black" weight={600} margin="0">
                    Registro de firmas
                  </Text>
                </CardSectionAccount>
              </IconsSectionAccount>
            </Column>
          </Row>
          <Row>
            <Column span={12} as={SectionInicia}>
              <Title
                color="Eerie_Black"
                tagName="h1"
                size={9}
                text="Inicia"
                margin="99px 0 63px"
              />
              <Icon
                icon="arrowDownCirle"
                size="xxlarge"
                color="Gradients_01"
                colorMobile="Primary_600"
              />
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <StepsCard
                image={ImgGT3}
                title="Paso 1"
                text="Información personal"
              />
            </Column>
          </Row>
          <Row>
            <BeneficiaryForm
              professionsList={professionsList}
              telephoneList={telephoneList}
            />
          </Row>
          <Row>
            <Column span={12}>
              <StepsCard
                image={ImgGT2}
                title="Paso 2"
                text="Apertura de cuenta"
              />
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <Description>
                <ImageContainer>
                  <Image srcImg={LogoGT} />
                  <Image srcImg={BankClock} />
                </ImageContainer>
                <TitleSectionStep>
                  <Text
                    size={3}
                    color="Eerie_Black"
                    align="center"
                    weight={600}
                  >
                    <Span>Banco G&T</Span> realizará la apertura de la cuenta
                    para que puedas gozar de todos los beneficios lo más pronto
                    posible
                  </Text>
                </TitleSectionStep>
              </Description>
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <StepsCard
                image={ImgGT}
                title="Paso 3"
                text="Registro de firmas"
              />
            </Column>
          </Row>
          <Row>
            <Column span={12}>
              <DescriptionStep>
                <IconSectionStep>
                  <Icon icon="note" size="xxxlarge" color="Primary_600" />
                  <Icon icon="write" size="xxxlarge" color="Primary_600" />
                </IconSectionStep>
                <TitleSectionStep>
                  <Text
                    size={3}
                    color="Eerie_Black"
                    align="center"
                    weight={600}
                  >
                    Un agente de <Span>Banco G&T</Span> se pondrá en contacto
                    contigo en un plazo de hasta <Span>48 horas</Span> para
                    coordinar el registro de tu firma y la entrega de la tarjeta
                    de débito.
                  </Text>
                </TitleSectionStep>
              </DescriptionStep>
            </Column>
          </Row>
        </Container>
      </Layout>
    </ThemeProvider>
  );
};

export default withTranslation("ns")(HomePage);
